/**
 * Function that loops through an object and warns falsy values.
 * To provide specific error messages use the 2nd argument mapping those messages
 * Only falsy values are logged, truthy won't produce any side effect.
 *
 * Usage:
 *
 * logReport({foo:false,bar:true})
 * // Warns the message "logReport: property 'foo' is falsy"
 *
 * logReport({foo:false,bar:true},{foo:"missing foo"})
 * // Warns the message "missing foo"
 *
 * @param {object} target falsy values will be warned via console.
 * @param {object} messages object mapping the properties from *target* with a string defining a log for that
 * @param {warn|error} messages object mapping the properties from *target* with a string defining a log for that
 */
const logReport = (target, messages = {}, severity = "warn") => {
    if (!Object.keys(target).length) {
        return;
    }
    for (const [key, exists] of Object.entries(target)) {
        // Log when falsy
        if (!exists) {
            const msg =
                key in messages ? messages[key] : `unexpected value found: "${key}=${target[key]}"`;
            if (severity === "error") {
                console.error(msg);
            }
            if (severity === "warn") {
                console.warn(msg);
            }
        }
    }
};
export default logReport;
